<template>
  <div>
    <b-card title="Relatórios">
      <b-col lg="12" class="my-6">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-2"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
              @input="myFilter"
            />

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Limpar</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-table
        ref="selectableTable"
        :items="reports"
        :fields="columns"
        striped
        responsive
        class="mb-0"
        :select-mode="'single'"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
        :is-loading.sync="isLoading"
      >
        <template #cell(selecione)="row">
          <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
          <b-form-checkbox
            v-model="row.detailsShowing"
            @change="verificaParametro(row)"
          >
            {{ row.detailsShowing ? "Esconder Filtros" : "Mostrar Filtros" }}
          </b-form-checkbox>
        </template>

        <!-- full detail on click -->
        <template #row-details="row">
          <b-card>
            <b-row
              v-if="row.item.parametros.length > 0 && row.item.parametros[0]"
              class="mb-2"
            >
              <b-col
                v-if="report.Data_inicial !== undefined"
                md="6"
                class="mb-1"
              >
                <b-form-group label="Data Inícial" label-for="v-dataInicio">
                  <flat-pickr
                    v-model="report.Data_inicial"
                    name="v-dataInicio"
                    class="form-control"
                    :config="{
                      altInput: true,
                      altFormat: 'd/m/Y',
                      enableTime: false,
                      dateFormat: 'd/m/Y',
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="report.Data_final !== undefined" md="6" class="mb-1">
                <b-form-group label="Data Final" label-for="v-dataFinal">
                  <flat-pickr
                    v-model="report.Data_final"
                    name="v-dataFinal"
                    class="form-control"
                    :config="{
                      altInput: true,
                      altFormat: 'd/m/Y',
                      enableTime: false,
                      dateFormat: 'd/m/Y',
                    }"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_TIPOREGISTRO !== undefined"
                cols="12"
                lg="6"
              >
                <b-form-group label="Tipo Registro" label-for="v-tipo">
                  <v-select
                    v-model="report.ID_TIPOREGISTRO.id"
                    label="descricao"
                    :options="comboTypesRegister"
                    :reduce="(comboTypesRegister) => comboTypesRegister.id"
                    @input="
                      setValue('ID_TIPOREGISTRO', report.ID_TIPOREGISTRO.id)
                    "
                  />
                </b-form-group>
              </b-col>

              <b-col v-if="report.DTYPE !== undefined" cols="12" lg="6">
                <b-form-group label="Categoria / Tipo (DTYPE)" label-for="v-dtype">
                  <v-select
                    v-model="report.DTYPE"
                    label="text"
                    :options="[
                      {id: 'Associado', text: 'Associado'}, 
                      {id: 'Agregado', text: 'Agregado'}, 
                      {id: 'Dependente', text: 'Dependente'}, 
                      {id: 'Funcionario', text: 'Funcionário'},
                      {id: 'Outro', text: 'Outro'}
                    ]"
                    :reduce="item => item.id"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_REGISTRO_LIST !== undefined"
                cols="12"
                lg="12"
              >
                <b-form-group label="Registro de Socios" label-for="v-registro">
                  <v-select
                    v-model="selectedRegistros"
                    label="nome"
                    :multiple="true"
                    :filterable="false"
                    :options="comboRegisterSocios"
                    :selectable="() => selectedRegistros.length < 100"
                    :clearable="true"
                    :close-on-select="false"
                    :clear-search-on-select="false"
                    @search="onSearch"
                    @input="updateSelectedRegistros"
                  >
                    <template #no-options>
                      Pesquisa registro por nome
                    </template>
                    <template #option="{ nome }">
                      <div class="d-center">
                        {{ nome }}
                      </div>
                    </template>
                    <template #selected-option="{ nome }">
                      <div class="selected d-center">
                        {{ nome }}
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_REGISTRO_LIST_AGREGADO !== undefined"
                cols="12"
                lg="12"
              >
                <b-form-group
                  label="Registro de Aregados"
                  label-for="v-registro"
                >
                  <v-select
                    v-model="report.ID_REGISTRO_LIST_AGREGADO.id"
                    label="nome"
                    :multiple="true"
                    :filterable="false"
                    :options="comboRegisterAgregados"
                    :selected="report.ID_REGISTRO_LIST_AGREGADO.id"
                    @search="onSearchAgregados"
                  >
                    <template slot="no-options">
                      Pesquisa registro por nome
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_TIPOREGISTRO_AGREGADOS !== undefined"
                cols="12"
                lg="6"
              >
                <b-form-group label="Tipo Registro" label-for="v-tipo">
                  <v-select
                    v-model="report.ID_TIPOREGISTRO_AGREGADOS.id"
                    label="descricao"
                    :options="comboTypesRegister"
                    :reduce="(comboTypesRegister) => comboTypesRegister.id"
                    @input="
                      setValue(
                        'ID_TIPOREGISTRO_AGREGADOS',
                        report.ID_TIPOREGISTRO_AGREGADOS.id
                      )
                    "
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_TIPOREGISTRO_DEPENDENTES !== undefined"
                cols="12"
                lg="6"
              >
                <b-form-group label="Tipo Registro" label-for="v-tipo">
                  <v-select
                    v-model="report.ID_TIPOREGISTRO_DEPENDENTES.id"
                    label="descricao"
                    :options="comboTypesRegister"
                    :reduce="(comboTypesRegister) => comboTypesRegister.id"
                    @input="
                      setValue(
                        'ID_TIPOREGISTRO_DEPENDENTES',
                        report.ID_TIPOREGISTRO_DEPENDENTES.id
                      )
                    "
                  />
                </b-form-group>
              </b-col>

              <b-col v-if="report.CIDADE !== undefined" cols="12" lg="6">
                <b-form-group label="UF" label-for="v-tipo">
                  <v-select
                    v-model="uf"
                    label="descricao"
                    :options="comboUfs"
                    :reduce="(comboUfs) => comboUfs.id"
                    @input="loadComboCidadePorUf(uf)"
                  />
                </b-form-group>
              </b-col>

              <b-col v-if="report.CIDADE !== undefined" cols="12" lg="6">
                <b-form-group label="Cidade" label-for="v-tipo">
                  <v-select
                    v-model="report.CIDADE.id"
                    label="descricao"
                    :options="comboCidades"
                    :reduce="(comboCidades) => comboCidades.id"
                    @input="setValue('CIDADE', report.CIDADE.id)"
                  />
                </b-form-group>
              </b-col>

              <b-col v-if="report.ID_SITUACAO !== undefined" cols="12" lg="6">
                <b-form-group label="Situacao" label-for="v-situacao">
                  <v-select
                    v-model="report.ID_SITUACAO.id"
                    label="nome"
                    :options="comboSituacaoRegistro"
                    :reduce="
                      (comboSituacaoRegistro) => comboSituacaoRegistro.id
                    "
                    @input="setValue('ID_SITUACAO', report.ID_SITUACAO.id)"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_ESPECIALIDADE !== undefined"
                cols="12"
                lg="6"
              >
                <b-form-group label="Especialidade" label-for="v-especialidade">
                  <v-select
                    v-model="report.ID_ESPECIALIDADE.id"
                    label="nome"
                    :options="comboEspecialidades"
                    :reduce="(comboEspecialidades) => comboEspecialidades.id"
                    @input="
                      setValue('ID_ESPECIALIDADE', report.ID_ESPECIALIDADE.id)
                    "
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="report.ID_PROFISSIONAL !== undefined"
                cols="12"
                lg="6"
              >
                <b-form-group label="Profissional" label-for="v-situacao">
                  <v-select
                    v-model="report.ID_PROFISSIONAL.id"
                    label="nome"
                    :options="comboProfissionals"
                    :reduce="(comboProfissionals) => comboProfissionals.id"
                    @input="
                      setValue('ID_PROFISSIONAL', report.ID_PROFISSIONAL.id)
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="p-1">
              <b-col cols="12">
                <div class="d-flex">
                  <b-overlay
                    variant="white"
                    :show="loading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                    class="mr-2"
                  >
                    <template #overlay>
                      <div class="d-flex align-items-center">
                        <b-spinner small type="grow" variant="primary" />
                        <b-spinner type="grow" variant="primary" />
                        <b-spinner small type="grow" variant="primary" />
                        <span class="sr-only">Aguarde...</span>
                      </div>
                    </template>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mr-1"
                      @click="printReport(row.item)"
                    >
                      {{ loading ? "Aguarde..." : "Imprimir" }}
                    </b-button>
                  </b-overlay>
                  
                  <b-overlay
                    v-if="row.item.nomeAmigavel === 'Listagem Eleitoral de Sócios'"
                    variant="white"
                    :show="loadingExcel"
                    spinner-variant="success"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                  >
                    <template #overlay>
                      <div class="d-flex align-items-center">
                        <b-spinner small type="grow" variant="success" />
                        <b-spinner type="grow" variant="success" />
                        <b-spinner small type="grow" variant="success" />
                        <span class="sr-only">Aguarde...</span>
                      </div>
                    </template>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      @click="generateExcelReport(row.item)"
                    >
                      <feather-icon
                        v-if="!loadingExcel"
                        icon="FileTextIcon"
                        size="16"
                        class="mr-1"
                      />
                      <b-spinner
                        v-else
                        small
                        type="grow"
                        variant="light"
                        class="mr-1"
                      />
                      {{ loadingExcel ? "Aguarde..." : "Exportar Listagem" }}
                    </b-button>
                  </b-overlay>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <template #cell(avatar)="data">
          <b-avatar :src="data.value" />
        </template>

        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
      </b-table>
      <div>
        <b-pagination
          :value="1"
          :total-rows="tableConfigs.totalElements"
          :per-page="tableConfigs.size"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @change="handleChangePage"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { VueGoodTable } from "vue-good-table";
import {
  BModal,
  BButton,
  BCol,
  BRow,
  BFormGroup,
  BAlert,
  BCardText,
  BFormInput,
  BCollapse,
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BOverlay,
  BSpinner,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import mixinsGlobal from "@/mixins";
import _ from "lodash";
import reportServices from "@/api/report/reportServices";

export default {
  name: "ReportAssociantes",
  components: {
    VueGoodTable,
    BCardCode,
    BButton,
    BModal,
    BAlert,
    BCardText,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BCollapse,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    vSelect,
    BSpinner,
    BOverlay,
    BTable,
    BFormCheckbox,
    flatPickr,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],

  computed: {
    ...mapState("combosModule", {
      comboTypesRegister: (state) => state.comboTypesRegister,
      comboUfs: (state) => state.comboUfs,
      comboCidades: (state) => state.comboCidades,
      comboSituacaoRegistro: (state) => state.comboSituacaoRegistro,
      comboProfissional: (state) => state.comboProfissional,
      comboEspecialidades: (state) => state.comboEspecialidades,
    }),
  },
  data() {
    return {
      reports: [],
      selectedRegistros: [],
      filter: null,
      filterOn: [],
      uf: {
        id: 26,
        descricao: "PE",
      },
      parametros: {
        dataInicial: {
          existeParametro: false,
          valor: "",
        },
        dataFinal: {
          existeParametro: false,
          valor: "",
        },
      },
      columns: [
        "Selecione",
        {
          key: "nomeAmigavel",
          label: "Relatório",
          stickyColumn: true,
          isRowHeader: true,
        },
      ],
      report: {},
      loading: false,
      loadingExcel: false,
      selected: [],
      tableConfigs: {
        last: false,
        totalPages: 5,
        totalElements: 41,
        size: 10,
        number: 0,
      },
      pageConfig: {
        page: 1,
        size: 10,
        sort: "nome",
        order: "asc",
      },
      pageLength: 5,
      dir: false,
      isLoading: false,
      comboProfissionals: [],
      existeEspecialidade: false,
      comboRegisterSocios: [],
      comboRegisterAgregados: [],
    };
  },
  methods: {
    setValue(field, value) {
      if (this.report[field].id) {
        if (
          field !== "ID_SITUACAO" &&
          field !== "ID_ESPECIALIDADE" &&
          field !== "ID_PROFISSIONAL" &&
          field !== "ID_REGISTRO_LIST" &&
          field !== "ID_REGISTRO_LIST_AGREGADO"
        ) {
          this.report = {};
        }
        this.report[field] = { id: value };
        if (field === "ID_ESPECIALIDADE" && this.report["ID_PROFISSIONAL"]) {
          this.loadProfissional(this.report["ID_ESPECIALIDADE"]["id"]);
        }
      }
    },
    loadProfissional(idEspecialidade) {
      this.comboProfissionals = [];
      if (!idEspecialidade) {
        this.$store
          .dispatch("combosModule/loadComboProfissionalByName", "a")
          .then((response) => {
            this.comboProfissionals = response.data.content.map((item) => ({
              id: item.id,
              nome: item.nome,
            }));
          });
        return;
      }
      this.$store
        .dispatch(
          "combosModule/loadComboProfissionalByIdEspecialidade",
          idEspecialidade
        )
        .then((response) => {
          this.comboProfissionals = response.data.map((item) => ({
            id: item.id,
            nome: item.registro.nome,
          }));
        });
    },
    desmarcaSelecionados(rows, item) {
      rows.forEach((row) => {
        if (item.nome !== row.nome && row._showDetails) {
          row._showDetails = false;
        }
      });
    },
    verificaParametro(row) {
      this.desmarcaSelecionados(this.$refs.selectableTable.localItems, row);
      row.toggleDetails();
      row.selectRow();
      row.item.parametros;
      const that = this;
      that.report = {};
      that.existeEspecialidade = false;
      row.item.parametros.forEach((param) => {
        if (param == "Data_inicial") {
          that.report.Data_inicial = "";
        }
        if (param == "Data_final") {
          that.report.Data_final = "";
        }

        if (param == "DTYPE") {
          that.$set(that.report, "DTYPE", "Associado");
        }

        if (param == "ID_TIPOREGISTRO") {
          that.report.ID_TIPOREGISTRO = {};
          that.loadComboTipoRegistro(1);
        }

        if (param == "ID_TIPOREGISTRO_DEPENDENTES") {
          that.report.ID_TIPOREGISTRO_DEPENDENTES = {};
          that.loadComboTipoRegistro(2);
        }

        if (param == "ID_TIPOREGISTRO_AGREGADOS") {
          that.report.ID_TIPOREGISTRO_AGREGADOS = {};
          that.loadComboTipoRegistro(3);
        }

        if (param == "CIDADE") {
          that.report.CIDADE = {};
          that.loadComboUfs(this.uf.id);
          that.loadComboCidadePorUf(this.uf.id);
        }

        if (param == "ID_SITUACAO") {
          that.report.ID_SITUACAO = {};
          that.loadComboSituacao();
        }

        if (param == "ID_ESPECIALIDADE") {
          that.report.ID_ESPECIALIDADE = {};
          that.loadComboEspecialidades();
        }

        if (param == "ID_PROFISSIONAL") {
          that.report.ID_PROFISSIONAL = {};
        }

        if (param == "ID_REGISTRO_LIST") {
          that.loadComboRegisterSocios("a");
          that.report.ID_REGISTRO_LIST = {};
        }

        if (param == "ID_REGISTRO_LIST_AGREGADO") {
          that.loadComboRegisterAgregados("a");
          that.report.ID_REGISTRO_LIST_AGREGADO = {};
        }
      });
      if (!this.existeEspecialidade) {
        this.loadProfissional();
      }
    },
    loadComboRegisterSocios(nome) {
      this.$store
        .dispatch("combosModule/loadComboRegisterSocios", nome)
        .then((response) => {
          if (this.report.ID_REGISTRO_LIST?.id) {
            const existingIds = this.report.ID_REGISTRO_LIST.id.map(
              (item) => item.id || item
            );
            const newItems = response.data.content.filter(
              (item) => !existingIds.includes(item.id || item)
            );

            let newLIst = [];
            newItems.forEach((item) => {
              newLIst.push({
                id: item.id,
                nome: item.matricula + " - " + item.nome,
              });
            });

            this.comboRegisterSocios = [
              ...this.report.ID_REGISTRO_LIST.id,
              ...newLIst,
            ];
          } else {
            let newLIst = [];
            response.data.content.forEach((item) => {
              newLIst.push({
                id: item.id,
                nome: item.matricula + " - " + item.nome,
              });
            });
            this.comboRegisterSocios = [...newLIst];
          }
        });
    },
    loadComboRegisterAgregados(nome) {
      this.$store
        .dispatch("combosModule/loadComboRegisterAgregados", nome)
        .then((response) => {
          if (this.report.ID_REGISTRO_LIST_AGREGADO?.id) {
            const existingIds = this.report.ID_REGISTRO_LIST_AGREGADO.id.map(
              (item) => item.id || item
            );
            const newItems = response.data.content.filter(
              (item) => !existingIds.includes(item.id || item)
            );

            let newLIst = [];
            newItems.forEach((item) => {
              newLIst.push({
                id: item.id,
                nome: item.matricula + " - " + item.nome,
              });
            });

            this.comboRegisterAgregados = [
              ...this.report.ID_REGISTRO_LIST_AGREGADO.id,
              ...newLIst,
            ];
          } else {
            let newLIst = [];
            response.data.content.forEach((item) => {
              newLIst.push({
                id: item.id,
                nome: item.matricula + " - " + item.nome,
              });
            });
            this.comboRegisterAgregados = [...newLIst];
          }
        });
    },
    loadComboSituacao() {
      this.$store.dispatch("combosModule/loadComboSituacaoRegistro");
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      loading(true);
      if (search && search.length > 2) {
        const result = vm.loadComboRegisterSocios(search);
        if (result && typeof result.then === "function") {
          return result.finally(() => {
            loading(false);
          });
        }
      }
      vm.$set(vm, "comboRegisterSocios", []);
      loading(false);
      return Promise.resolve();
    }, 350),
    onSearchAgregados(search, loading) {
      loading(true);
      this.searchAgregados(loading, search, this);
    },
    searchAgregados: _.debounce(async (loading, search, vm) => {
      vm.loadComboRegisterAgregados(search);
      loading(false);
    }, 350),
    updateSelectedRegistros(selected) {
      if (!this.report.ID_REGISTRO_LIST) {
        this.$set(this.report, "ID_REGISTRO_LIST", { id: [] });
      }
      this.report.ID_REGISTRO_LIST.id = Array.isArray(selected)
        ? [...selected]
        : [selected];
    },
    printReport(reportSelecionado) {
      this.loading = true;
      const reportName = reportSelecionado.nome;
      
      // Intercepta relatórios de cadastros cancelados (Unificado na nova Report-API)
      if (reportName === 'cadastro_cancelados_api') {
        const params = {
          DTYPE: this.report.DTYPE || 'Associado'
        };

        if (this.report.Data_inicial && this.report.Data_final) {
          params.DATA_INICIAL = this.report.Data_inicial;
          params.DATA_FINAL = this.report.Data_final;
        }

        return reportServices.printManagerialReport('cadastro_cancelados.html', params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      // Intercepta relatórios migrados para o Python/Whiseprint
      if (reportName === 'agendamentos_profissional_dia') {
        const params = {
          ID_PROFISSIONAL: this.report.ID_PROFISSIONAL?.id,
          ID_ESPECIALIDADE: this.report.ID_ESPECIALIDADE?.id,
          DATA: this.report.Data_inicial // No Jasper diário usa Data_inicial
        }
        return reportServices.printReportAgendamentosDia(params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'agendamentos_profissional_periodo') {
        const params = {
          ID_PROFISSIONAL: this.report.ID_PROFISSIONAL?.id,
          ID_ESPECIALIDADE: this.report.ID_ESPECIALIDADE?.id,
          DATA_INICIO: this.report.Data_inicial,
          DATA_FIM: this.report.Data_final
        }
        return reportServices.printReportAgendamentosPeriodo(params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'estatisticas_atendimento') {
        const params = {
          ID_PROFISSIONAL: this.report.ID_PROFISSIONAL?.id,
          ID_ESPECIALIDADE: this.report.ID_ESPECIALIDADE?.id,
          DATA_INICIO: this.report.Data_inicial,
          DATA_FIM: this.report.Data_final
        }
        return reportServices.printReportEstatisticasAtendimento(params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'mensalidades_socios_neos_quitadas_por_periodo') {
        const params = {
          DATA_INICIAL: this.report.Data_inicial,
          DATA_FINAL: this.report.Data_final
        }
        return reportServices.printReportQuitadasPeriodo(params, 'neos_mensalidades')
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'mensalidades_socios_convidado_quitadas_por_periodo') {
        const params = {
          DATA_INICIAL: this.report.Data_inicial,
          DATA_FINAL: this.report.Data_final
        }
        return reportServices.printReportQuitadasPeriodo(params, 'convidado_mensalidades')
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'emprestimos_socios_neos_quitadas_por_periodo') {
        const params = {
          DATA_INICIAL: this.report.Data_inicial,
          DATA_FINAL: this.report.Data_final
        }
        return reportServices.printReportQuitadasPeriodo(params, 'neos_emprestimos')
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'aging_financeiro_detalhado') {
        return reportServices.printManagerialReport('relatorio-aging.html', {})
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'fluxo_caixa_diario_real_prev') {
        const params = {
          DATA_INICIO: this.report.Data_inicial,
          DATA_FIM: this.report.Data_final
        }
        return reportServices.printManagerialReport('relatorio-fluxo-caixa-diario.html', params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'fechamento_caixa_diario_transacoes') {
        const params = {
          DATA: this.report.Data_inicial
        }
        return reportServices.printManagerialReport('relatorio-fechamento-caixa.html', params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'analise_liquidacao_meio_pagamento') {
        const params = {
          DATA_INICIO: this.report.Data_inicial,
          DATA_FIM: this.report.Data_final
        }
        return reportServices.printManagerialReport('relatorio-analise-liquidacao.html', params)
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      if (reportName === 'mrr_previsibilidade_receita') {
        return reportServices.printManagerialReport('relatorio-mrr.html', {})
          .then(res => {
            this.loading = false
            if (res.error) this.MensagemError('Erro', res.error)
          })
      }

      this.report.nome = reportName;
      this.report.valor = [];
      if (reportSelecionado.id) {
        this.report.valor.push(parseInt(reportSelecionado.id));
      }
      reportSelecionado.parametros.forEach((valor) => {
        let param = this.report[valor];
        if (param?.id) {
          param = param.id;
        }

        if (
          valor == "ID_REGISTRO_LIST" ||
          valor == "ID_REGISTRO_LIST_AGREGADO"
        ) {
          let list = [];
          param.forEach((item) => {
            list.push(item.id);
          });
          this.report.valor.push(list.toString());
        } else {
          this.report.valor.push(param);
        }
      });
      this.$store
        .dispatch("reportModule/printReport", this.report)
        .then((response) => {
          if (response.error) {
            this.showMessageSuccess("Limite Excedido", response.message);
          }
          this.openNewAbaBase64(response.data);
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
    
    generateExcelReport(reportSelecionado) {
      this.loadingExcel = true;
      
      reportServices.generateExcelReport(reportSelecionado)
        .then((response) => {
          if (response.error) {
            this.MensagemError('Erro ao gerar relatório Excel', response.error);
          } else {
            this.showMessageSuccess('Sucesso', response.msg);
          }
          this.loadingExcel = false;
        })
        .catch((err) => {
          console.error('Erro ao gerar relatório Excel:', err);
          this.MensagemError('Erro', 'Erro ao gerar relatório Excel');
          this.loadingExcel = false;
        });
    },
    handleChangePage(page) {
      this.pageConfig.page = page;
      this.carregarListaRelatorioPorModulo();
    },
    myFilter: _.debounce(function () {
      this.reports = [];
      this.isLoading = true;
      this.pageConfig.module = this.$route.name;
      this.pageConfig.filter = this.filter;
      this.$store
        .dispatch("reportModule/listagemGeral", this.pageConfig)
        .then((response) => {
          this.pageConfig.page = response.data.pageable.pageNumber;
          this.tableConfigs.last = response.data.last;
          this.tableConfigs.totalPages = response.data.totalPages;
          this.tableConfigs.totalElements = response.data.totalElements;
          this.tableConfigs.size = response.data.size;
          this.tableConfigs.number = response.data.number;
          this.reports = response.data.content;
          this.isLoading = false;
        });
    }, 500),
    carregarListaRelatorioPorModulo() {
      this.reports = [];
      this.isLoading = true;
      this.pageConfig.module = this.$route.name;
      this.$store
        .dispatch("reportModule/listagemGeral", this.pageConfig)
        .then((response) => {
          this.pageConfig.page = response.data.pageable.pageNumber;
          this.tableConfigs.last = response.data.last;
          this.tableConfigs.totalPages = response.data.totalPages;
          this.tableConfigs.totalElements = response.data.totalElements;
          this.tableConfigs.size = response.data.size;
          this.tableConfigs.number = response.data.number;
          this.reports = response.data.content;
          this.isLoading = false;
        });
    },
    loadComboTipoRegistro(tipo) {
      this.$store
        .dispatch("combosModule/loadComboTypesRegister", tipo)
        .then((response) => {});
    },
    loadComboCidadePorUf(uf) {
      if (this.report.CIDADE.id) {
        this.report.CIDADE.id = null;
      }
      this.$store.dispatch("combosModule/loadMunicipiosPorUf", uf);
    },
    loadComboUfs() {
      this.$store.dispatch("combosModule/loadUf");
    },
    loadComboEspecialidades() {
      this.existeEspecialidade = true;
      this.$store.dispatch("combosModule/loadComboEspecialidades");
    },
  },
  watch: {
    $route() {
      this.carregarListaRelatorioPorModulo();
    },
  },
  mounted() {
    this.carregarListaRelatorioPorModulo();
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
